import { api } from "./api";
import { toast } from "sonner";
import { openRazorpayCheckout } from "./razorpay";

/** Create an order for a package/service and open Razorpay checkout
 * (same flow as the Shop). Requires a signed-in user. */
export const buyPackage = async ({ id, name, price, user, navigate, onSuccess }) => {
  if (!user) {
    toast.error("Please sign in to purchase — your order will appear in your dashboard");
    navigate(`/login?next=${encodeURIComponent(window.location.pathname)}`);
    return;
  }
  try {
    const r = await api.post("/orders", {
      items: [{ id, name, qty: 1, price }],
      total: price,
      customer_name: user.name || "Member",
      customer_email: user.email,
      customer_phone: user.phone || "0000000000",
      address: "Package purchase",
      address_line1: "Package purchase",
      city: ",", state: ",", pincode: ",", country: "Package",
      notes: `Package purchase: ${name}`,
    });
    await openRazorpayCheckout({
      orderType: "shop",
      orderId: r.data.id,
      amount: r.data.total,
      name: user.name,
      email: user.email,
      description: name,
      onSuccess: () => {
        toast.success("Purchase confirmed — find it under Orders in your dashboard");
        onSuccess?.();
      },
    });
  } catch (e) {
    const d = e.response?.data?.detail;
    toast.error(typeof d === "string" ? d : "Could not start checkout");
  }
};
